import { Link } from '@atoms/Link/Link';

export const CustomPhotoUploadTextContent = () => {
  return (
    <div className="text-bodyLg my-4 flex flex-col gap-4">
      <p>
        Photos help us locate and assess the issue.{' '}
        <Link
          href="https://www.westminster.gov.uk/data-protection/report-it-image-disclaimer"
          className="text-action-link underline"
          linkType="inline"
          external={true}
        >
          Find out how we will be using your image.
        </Link>
      </p>
      <p className="font-semibold">
        Only if it is safe to do so, please take a photo of the EV charging
        point.
      </p>
      <p>
        You can upload up to 5 images. You can upload JPEG, PNG, GIF or WebP
        files.
      </p>
    </div>
  );
};
